export const SET_OFFERS = 'SET_OFFERS';
export const SET_OFFER = 'SET_OFFER';
export const SET_BUNDLES = 'SET_BUNDLES';
export const SET_BUNDLE = 'SET_BUNDLE';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_CURRENT_BUNDLES = 'SET_CURRENT_BUNDLES';
export const SET_CURRENT_ACCOUNTS = 'SET_CURRENT_ACCOUNTS';
